'use client';

import { ErrorOverlay } from '@/app/components/ErrorOverlay';

import { useRouter } from 'next/navigation';

/**
 * Página de error 404 - Página no encontrada.
 * Utiliza el componente NotificationMessage centrado en la pantalla.
 */
export default function NotFound() {
  const router = useRouter();

  const handleGoBack = () => {
    router.back();
  };

  const handleGoHome = () => {
    router.push('/');
  };

  return (
    <ErrorOverlay
      icon='bi-exclamation-triangle'
      title='Página no encontrada'
      text='Lo sentimos, la página que estás buscando no existe o ha sido movida.'
      primaryCallback={handleGoHome}
      secondaryCallback={handleGoBack}
    />
  );
}
